import { ICON_TYPES } from './iconTypes';

export default {
	cancel: {
		name: 'cancel',
		type: ICON_TYPES.materialIcons,
		text: 'Cancel',
	},
	menu: {
		name: 'md-menu',
		type: ICON_TYPES.ionicon,
		text: 'Menu',
	},
	verticalDots: {
		name: 'dots-vertical-circle-outline',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Menu',
	},
	arrowFirst: {
		name: 'play-skip-back',
		type: ICON_TYPES.ionicon,
		text: 'First',
	},
	arrowPrevious: {
		name: 'caret-back',
		type: ICON_TYPES.ionicon,
		text: 'Previous',
	},
	arrowNext: {
		name: 'caret-forward',
		type: ICON_TYPES.ionicon,
		text: 'Next',
	},
	arrowLast: {
		name: 'play-skip-forward',
		type: ICON_TYPES.ionicon,
		text: 'Last',
	},
	back: {
		name: 'arrow-back',
		type: ICON_TYPES.ionicon,
		text: 'Back',
	},
	login: {
		name: 'login',
		type: ICON_TYPES.materialIcons,
		text: 'Login',
	},
	resetPassword: {
		name: 'account-lock-open',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Reset',
	},
	logout: {
		name: 'logout',
		type: ICON_TYPES.materialIcons,
		text: 'Logout',
	},
	settings: {
		name: 'settings',
		type: ICON_TYPES.ionicon,
		text: 'Settings',
	},
	support: {
		name: 'md-help-circle-outline',
		type: ICON_TYPES.ionicon,
		text: 'Support',
	},
	library: {
		name: 'library-outline',
		type: ICON_TYPES.ionicon,
		text: 'Library',
	},
	home: {
		name: 'home',
		type: ICON_TYPES.ionicon,
		text: 'Home',
	},
	caretDown: {
		name: 'caret-down',
		type: ICON_TYPES.ionicon,
		text: 'Hide',
	},
	caretUp: {
		name: 'caret-up',
		type: ICON_TYPES.ionicon,
		text: 'View',
	},
	refresh: {
		name: 'refresh',
		type: ICON_TYPES.fontAwesome,
		text: 'refresh',
	},
	clockFast: {
		name: 'clock-fast',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'EMS'
	},
	fullscreen: {
		name: 'fullscreen',
		type: ICON_TYPES.materialIcons,
		text: 'Fullscreen',
	},
};